/*=========================================================================================
  File Name: moduleEcommerceState.js
  Description: Ecommerce Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/* eslint-disable */
export default {
	idForm: '', //Almacena el id del formulario
	idQuestion: 0,//El autoincrementado para el name de las preguntas
	id_page: '', // Contiene el id de la página actual
	id_page_temp: '', //Almacena temporalmente el id de la page para actualizar questions movidas de la pagina
	questions: [],//Almacena las questions correspondientes a la pagina
	paginas: [],//Almacena las paginas de la tabla pages del indexDB para recrear la paginación en la vista
	questionsChecks: [], //Array que contiene las preguntas a mover
	page: 1,//Autoincrementable para enumerar las paginas (name_page)
	keyContador: '', //ALmacena el key del contador para extraer su contador
	listForms: [], //Almacena todos los formularios para que el usuario seleccione cual va a trabajar.


}
/* eslint-enable */
